import { ModalOptions } from 'ng-zorro-antd/modal';

/**
 * Shared NzModal options for the full-screen file/attachment preview modals.
 * Spread into `modalService.create({...})` and add the specific `nzContent`
 * component and `nzWrapClassName`.
 */
export const FULLSCREEN_PREVIEW_MODAL_CONFIG: Partial<ModalOptions> = {
  nzTitle: '',
  nzFooter: null,
  nzClosable: false,
  nzMaskClosable: false,
  nzWidth: '100vw',
  nzStyle: {
    top: 0,
    paddingBottom: 0
  },
  nzBodyStyle: {
    'padding': '0',
    'height': '100vh',
    'overflow': 'hidden'
  }
};
